<!-- 餐厅管理-餐饮订单 -->

<template>
  <div class="catering-orders main-cnt">
    <div class="title">餐饮订单</div>
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 325px)" :apiName="DinnerApi.getDinnerOrder"
        :filters="filters" :columns="tableColumns" @onDetailsBtn="onDetailsBtn" @onPrint="onPrint">
        <template #pay_status="{ row }">
          <div class="status-text" :class="orderStatusColors(row.or_pay_status, 'pay')">{{ row.or_pay_status_text }}
          </div>
        </template>

        <template #odrg_status="{ row }">
          <div class="status-text" :class="orderStatusColors(row.odrg_status, 'work')">
            {{ row.odrg_status_text }}</div>
        </template>

        <!-- 退款 -->
        <template #fullRefund="{ row }">
          <template v-if="row.is_init_refund == 1 && authData.indexOf('r_ZnRkz001PzTFKL7EZ5jroG3Sa6In') != -1">
            <el-button class="red-font-btn" @click="onFullRefund(row)">退款</el-button>
          </template>
        </template>

      <template #print_stats="{ row }">
        <div class="status-text" :class="row.odrg_print_status == '1' ? 'btn-orange' : 'btn-grey'">{{ row.odrg_print_stats_text }}</div>
      </template>

        <!-- 取消退款 -->
        <template #cancelRefund="{ row }">
          <template v-if="row.is_cancel_refund == 1 &&authData.indexOf('r_l8HSIBbxJ6PcNLSxukFzm5sUmB1L') != -1">
            <el-popconfirm title="确定要取消该订单退款吗?" @confirm="onConfirmRefund(row)">
              <template #reference>
                <el-button class="theme-font-btn">取消退款</el-button>
              </template>
            </el-popconfirm>
          </template>
        </template>
      </common-table>
    </div>

    <!-- 详情 -->
    <DiningOrderDetail ref="refOrderInfo" @submit="onSubmit"></DiningOrderDetail>
  </div>
</template>
<script setup>
  import { ref, onMounted, computed, watch, } from "vue";
  import { DinnerApi, } from "@/plugins/api.js"; DinnerApi
  import { ElMessage, ElMessageBox, } from "element-plus";
  import { useStore } from "vuex";
  import { orderStatusColors, } from "@/utils/common.js";
  import { h } from 'vue';
  import DiningOrderDetail from "../components/DiningOrderDetail.vue";

  const store = useStore();
  const menuTokens = computed(() => store.state.menuToken.menuTokens);
  const authData = ref([]);
  watch(
    () => menuTokens.value,
    (data) => {
      if (data.length) {
        authData.value = data;
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
  /** 筛选条件列表 */
  const filters = ref([
    {
      filterType: "search",
      name: "kwz",
      value: "",
      placeholder: "请输入订单号进行查询",
    },
    {
      filterType: "select",
      name: "odrg_source",
      value: "",
      placeholder: "请选择订单来源",
      options: [
        { id: 1, label: '线上点餐' },
        { id: 2, label: '客房点餐' },
        { id: 3, label: '门店点餐' },
      ],
      val: "id",
      lab: "label",
    },
    {
      filterType: "select",
      name: "or_pay_status",
      value: "",
      placeholder: "请选择支付状态",
      options: [
        { id: 1, label: '待支付' },
        { id: 2, label: '已支付' },
        { id: 3, label: '已取消' },
        { id: 4, label: '申请退款中' },
        { id: 5, label: '已退款' },
      ],
      val: "id",
      lab: "label",
    },
    {
      filterType: "select",
      name: "odrg_status",
      value: "",
      placeholder: "请选择订单状态",
      options: [
        { id: 1, label: '待生效' },
        { id: 3, label: '待制作' },
        { id: 4, label: '制作中' },
        { id: 5, label: '已完成' },
        { id: 6, label: '已过期' },
        { id: 7, label: '已取消' },
      ],
      val: "id",
      lab: "label",
    },
  ]);
  /** 表格配置数据 */
  const tableColumns = ref([
    {
      prop: "or_sn",
      label: "订单号",
      minWidth: 150,
    },
    {
      prop: "or_allmoney",
      label: "订单金额",
    },
    {
      prop: "or_refund_money",
      label: "退款金额",
    },
    {
      prop: "or_integrate_money",
      label: "积分抵扣金额",
      minWidth: 110,
    },
    {
      prop: "or_integrate_refund_money",
      label: "积分退回金额",
      minWidth: 110,
    },
    {
      prop: "or_yhmoney",
      label: "优惠合计",
    },
    {
      prop: "or_true_money",
      label: "实付金额",
    },
    {
      prop: "dr_name",
      label: "门店",
    },
    {
      prop: "odrg_source_text",
      label: "订单来源",
    },
    {
      prop: "ctime_text",
      label: "下单时间",
      minWidth: 120,
    },
    {
      prop: "pay_status",
      label: "支付状态",
      type: "customRender",
      minWidth: 100,
    },
    {
      prop: "odrg_status",
      label: "订单状态",
      type: "customRender",
      minWidth: 100,
    },
    {
      prop: "print_stats",
      label: "打印状态",
      type: "customRender",
      minWidth: 100,
    },
    {
      type: "operation",
      prop: "",
      label: "操作",
      minWidth: 270,
      bottons: [
        {
          name: "详情",
          action: "onDetailsBtn",
          token: "r_8mFVi2afZJbvI3x2fu0S0mFd2lcj",
          className: "theme-font-btn",
        },
        {
          type: "customRender",
          name: "退款",
          action: "fullRefund",
        },
        {
          name: "取消退款",
          action: "cancelRefund",
          type: "customRender",
        },
        {
          name: "打印",
          action: "onPrint",
          token: "r_WlMWhvVvnjW4l1htyftX1FITFU1x",
          HiddenKey: "or_pay_status",
          showValue: [2],
          className: "theme-font-btn",
        },
      ],
    },
  ]);
  const tableRef = ref(null);  // 餐饮表格对象
  const refOrderInfo = ref(null);  // 详情对象
  /**
   * 
   * 详情按钮
   * 
   * **/
  const onDetailsBtn = (row) => {
    refOrderInfo.value.openDialog(row);
  }
  /**
   * 
   * 全部退款按钮
   * 
   * **/
  const onFullRefund = (row) => {
    ElMessageBox.confirm("", "温馨提示", {
      confirmButtonText: "确认退款",
      cancelButtonText: "取消",
      message: h('p', null, [
        h('div', null, `你确定整单退款？`),
        h('div', null, '操作一经确认不可撤销！'),
      ]),
    })
      .then(() => {
        const lastMoney = +row.or_money - +row.or_refund_money;
        DinnerApi.dinnerInitiateRefund({
          refund_money: lastMoney,
          sn: row.or_sn,
          refund_mode: 1,
        }).then((res) => {
          if (res.Code === 200) {
            tableRef.value.tableLoad();
            ElMessage.success('退款成功！');
          } else {
            ElMessage.error(res.Message);
          }
        });
      })
      .catch(() => { });
  }
  /**
   * 
   * 取消退款确定按钮
   * 
   * **/
  const onConfirmRefund = (row) => {
    DinnerApi.dinnerCancelRefund({ sn: row.or_sn }).then((res) => {
      if (res.Code === 200) {
        tableRef.value.tableLoad();
        ElMessage.success("取消退款成功！");
      } else {
        ElMessage.error(res.Message);
      }
    });
  }
  /**
   * 
   * 打印按钮
   * 
   * **/
  const onPrint = (row) => {
    DinnerApi.getPrintReceipts({ odrg_id: row.odrg_id }).then((res) => {
      if (res.Code === 200) {
        ElMessage.success("打印成功！");
        tableRef.value.tableLoad();
      } else {
        ElMessage.error(res.Message);
      }
    });
  }
  /**
   * 
   * 刷新列表数据
   * 
   * **/
  const onSubmit = () => {
    tableRef.value.tableLoad();
  } 
  onMounted(() => {
    tableRef.value.tableLoad();
  });
</script>

<style lang="scss">
  .catering-orders {
    font-family: "Source Han Sans CN";

    .xs-m-t {
      margin-top: 5px;
    }

    .content {
      padding: 20px;
    }

    .order-info {
      .catering-infor-title {
        color: #92979E;
        width: 80px;
        text-align: left;
        margin-bottom: 10px;
        flex-shrink: 0;
      }

      .order-content {
        background-color: #f9f9fb;
        padding: 10px;
      }

      .order-fee {
        color: var(--text-color);
        margin-top: 10px;
      }

      .order-fee-title {
        margin-right: 15px;
      }

      .order-fee-num {
        text-align: end;
      }

      .catering-infor-content {
        color: #262C30;
      }

      .order-table .el-table__cell {
        padding: 9px 0;
      }

      .order-table th.el-table__cell {
        background-color: var(--search-bg-color);
        padding: 9px 0;
        font-size: 15px;
        color: var(--text-color);
      }

      .order-table td.el-table__cell div span {
        font-size: 14px;
      }

      .total-num {
        font-size: 18px;
      }

      .text-blue {
        color: var(--theme-color);
      }
    }
  }
</style>